module.exports = __webpack_public_path__ + "img/captains_log.2eaa22a8.svg";